export default "/_next/static/images/72/star-review-72c2bc4bb728b0da7438d17356899060.png";